import React, { useState, useContext, useEffect } from 'react';
import { withStyles } from "@material-ui/core/styles";
import CloseButtonDialog from './CloseButtonDialog';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { Typography } from '@material-ui/core';
import { TipoDoc } from 'App/Helpers/Iconos';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';

import moment from 'moment';
import _ from 'underscore';

import { RecibidosContext } from 'App/Recibidos/store';
import { DigitoVerificador, separadorMiles } from "App/Helpers/Genericos";


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    section: {
        marginRight: theme.spacing.unit * 2,
        marginTop: theme.spacing.unit * 1,
    },
    DTEs: {
        paddingLeft: theme.spacing.unit * 2,
    },
    fullWidth: {
        width: "100%"
    },
    padding: {
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
    },
});

function RespuestaComercial(props) {
    const { classes } = props;

    const estadosDocumento = [
        {
            codEstado: "ACD",
            nombreEstado: "Acepta contenido del documento"
        },
        {
            codEstado: "ERM",
            nombreEstado: "Recibo de mercaderías entregadas o servicios prestados (Ley 19.983)"
        },
        {
            codEstado: "RCD",
            nombreEstado: "Reclamo al contenido del documento"
        },
        {
            codEstado: "RFP",
            nombreEstado: "Reclamo por falta parcial de mercaderías o servicios"
        },
        {
            codEstado: "RFT",
            nombreEstado: "Reclamo por falta total de mercaderías o servicios"
        }
    ]
    const [estadoDocumento, setEstadoDocumento] = useState("");
    const [cargando, setCargando] = useState(false);

    const recibidosContext = useContext(RecibidosContext);

    function changeEstadoDocumento(evt) {
        setEstadoDocumento(evt.target.value);
    }

    function handleToggleModal() {
        recibidosContext.dispatch({ type: "toggleRespuestaComercial" });
        setEstadoDocumento("")
    }

    function enviarRespuesta() {
        var documentos = recibidosContext.state.documentos.map(e => {
            return {
                IdDte: e.id_dte,
                Accion: estadoDocumento
            }
        })
        setCargando(true);
        axios.post('/api/intercambio/RCV/Respuesta', documentos).then((dte) => {
            var errores = _.filter(dte, e => e.Error);
            var plural = dte.length>1?"s":"";
            if (errores.length > 0) {
                var ix = 1;
                var errorList = dte.reduce((s, i) => {
                    return s + (ix++ + ") " + (i.Error ? i.Error : "Enviado exitosamente") + "\n");
                }, "");
                alert("Se han encontrado las siguientes observaciones al responder documento"+plural+":\n" + errorList);
            } else {
                alert("Documento"+plural+" en proceso de respuesta comercial")
            }
        }).catch(e => /*alert(e.response.data.Mensaje)*/{}).finally(() => { handleToggleModal(); setCargando(false); });
    }

    var content =
        <div>
            <Grid container spacing={24} className={classes.DTEs}>
                {recibidosContext.state.documentos.map(doc => (
                    <Grid container spacing={24} className={classes.section}>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid xs={3}><Typography><b>Rut Emisor</b></Typography></Grid>
                                <Grid xs={3}><Typography>{(doc.rut||"").toString().indexOf("-")>-1?doc.rut:(separadorMiles(doc.rut)+"-"+DigitoVerificador(doc.rut))}</Typography></Grid>
                                <Grid xs={3}><Typography><b>Razón social</b></Typography></Grid>
                                <Grid xs={3}><Typography>{doc.razon_social}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid xs={4}><Typography><strong>{TipoDoc(doc.tipo_dte, "text")}</strong></Typography></Grid>
                                <Grid xs={2}><Typography>{doc.folio}</Typography></Grid>
                                <Grid xs={3}><Typography><b>Fecha de emisión</b></Typography></Grid>
                                <Grid xs={3}><Typography>{moment(doc.fecha_emision).format("L")}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider variant="middle" />
                        </Grid>
                    </Grid>))}
            </Grid>
        </div>;

    const footer = (
        <div className={classes.fullWidth}>
            {cargando ?
                <Grid item xs="12">
                    <LinearProgress variant="query" />
                </Grid>
                : null}
            <FormControl fullWidth className={classes.padding}>
                <TextField
                    select
                    fullWidth
                    label="Respuesta Comercial"
                    margin="dense"
                    InputLabelProps={{ shrink: true }}
                    className={classes.dense}
                    value={estadoDocumento}
                    onChange={changeEstadoDocumento}>
                    {estadosDocumento.map((item) => {
                        return (
                            <MenuItem value={item.codEstado}>
                                {item.nombreEstado}
                            </MenuItem>
                        )
                    })}
                </TextField>
            </FormControl>
            <DialogActions>
                <Button onClick={handleToggleModal} color="secondary" autoFocus>
                    Cancelar
                </Button>
                <Button onClick={enviarRespuesta} disabled={estadoDocumento == "" || cargando} color="primary" autoFocus>
                    Aceptar
                </Button>
            </DialogActions>
        </div>
    );

    return (
        <div>
            <CloseButtonDialog open={recibidosContext.state.openRespuestaComercial} onClose={handleToggleModal} closeButton title={"Respuesta comercial para " + recibidosContext.state.documentos.length + " documento" + (recibidosContext.state.documentos.length > 1 ? "s" : "")} content={content} footer={footer} size="sm" />
        </div>
    );
}

export default withStyles(styles)(React.memo(RespuestaComercial));